import * as React from 'react';
import Overlay from 'components/Overlay';
import SearchOverlay from './SearchOverlay';

function SearchModal({ open, onClose }) {
  return (
    <Overlay open={open} onClose={onClose} mobileFullScreen hashKey="search">
      <Overlay.Header>
        Search...
      </Overlay.Header>
      <Overlay.Content>
        <SearchOverlay
          onSelect={onClose}
          backdrop={false}
          closeOnBlur={false}
          componentsProps={{
            paper: {
              elevation: 0,
            },
          }}
        />
      </Overlay.Content>
    </Overlay>

  );
}
export default SearchModal;
